module.exports = __webpack_public_path__ + "img/code.0b57271d.svg";